import RouteConfig from '../route/RouteConfig';
import { OidcSecure } from '@axa-fr/react-oidc-context';
import GlobalLoading from './GlobalLoading';

export default function Main() {
  return (
    <OidcSecure>
      <div className="w-full items-center flex flex-col bg-grey-background overflow-x-hidden">
        <div className="flex flex-col">
          <RouteConfig />
        </div>
      </div>
      <GlobalLoading />
    </OidcSecure>
  );
}
